import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

// A busca do FlipLeads e paginada por CURSOR (keyset), nao por offset: nao existe "pagina 7",
// existe "a proxima fatia depois desta". Por isso o meta guarda `nextCursor` e nao
// `currentPage`, e a lista CRESCE com `loadMore` em vez de ser substituida.
const state = {
  // Chaveado por CNPJ: e a identidade da linha na base publica, e o que o reveal usa para
  // remendar o registro depois da cobranca sem refazer a busca inteira.
  records: {},
  sortOrder: [],
  meta: {
    total: 0,
    // false quando o filtro sai das dimensoes do cubo (cnae/uf/porte): ai o total e um LIMITE
    // SUPERIOR e a tela precisa dizer "cerca de" em vez de fingir precisao.
    exact: true,
    status: 'ok',
    nextCursor: null,
    // Cursor nulo tem dois motivos e a tela diz o oposto em cada um. Preenchido com o teto do
    // servidor quando foi ELE que barrou; nulo quando o resultado acabou de verdade.
    depthCap: null,
  },
  // A MESMA FORMA que `SET_FLIP_LEADS_FACETS` escreve — cinco chaves, nao tres. As duas de
  // capacidade nascem `undefined` de proposito: e esse o terceiro estado que a tela le como
  // "ainda nao sei" (os computeds da SearchView testam `!== false`) enquanto a primeira chamada
  // de facetas nao volta. `false` aqui faria o trilho abrir escondendo controles que existem.
  //
  // Declaradas no estado inicial e nao so na mutation porque o Vue 2 nao observa chave que
  // aparece depois, e porque a divergencia entre as duas formas era o tipo de coisa que so se
  // descobre quando alguem le o estado antes da primeira resposta.
  facets: {
    uf: [],
    classe_porte: [],
    cnae: [],
    divida_disponivel: undefined,
    cnae_secundaria_disponivel: undefined,
  },
  appliedFilters: {},
  // null = nunca carregado ou falhou. A tela trata como "saldo desconhecido", que NAO bloqueia
  // revelar — quem decide nesse caso e o 402 do servidor.
  credits: null,
  uiFlags: {
    isFetching: false,
    isFetchingMore: false,
    isFetchingFacets: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
